import {
  BooleanInput,
  CreateButton,
  Datagrid,
  EditButton,
  FunctionField,
  List,
  ReferenceField,
  SelectInput,
  ShowButton,
  TextField,
  TextInput,
} from 'react-admin';
import { DataTableListActions } from 'src/client/components/data-table-list-actions';
import { ESTDateField } from 'src/client/components/custom-ra-fields/est-date-field';
import { includesInsensitive } from 'src/client/components/forms/form-utils';
import {
  AdvertiserRecord,
  ArchiveAdvertiserButton,
  activeAdvertiserFilter,
  advertiserTypeChoices,
  formatArchivedAtFilter,
  parseArchivedAtFilter,
} from './shared';

const advertiserFilters: JSX.Element[] = [
  <TextInput label="Name" source="name" {...includesInsensitive} alwaysOn />,
  <SelectInput label="Type" source="type" choices={advertiserTypeChoices} alwaysOn />,
  <BooleanInput
    label="Archived"
    source="archivedAt"
    format={formatArchivedAtFilter}
    parse={parseArchivedAtFilter}
    alwaysOn
  />,
];

const AdvertiserListActions = () => (
  <DataTableListActions filters={advertiserFilters}>
    <CreateButton label="Create Advertiser" />
  </DataTableListActions>
);

export const AdvertiserList = () => (
  <List
    actions={<AdvertiserListActions />}
    perPage={25}
    sort={{ field: 'name', order: 'ASC' }}
    filterDefaultValues={{ archivedAt: activeAdvertiserFilter }}
  >
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="name" sortable />
      <TextField source="type" sortable />
      <ReferenceField source="parentId" reference="advertisers" label="Agency" link="edit">
        <TextField source="name" emptyText="-" />
      </ReferenceField>
      <TextField source="adServerId" label="GAM/DCM Company ID" />
      <TextField source="externalPioId" label="PIO ID" />
      <ESTDateField source="createdAt" label="Created" sortable showTime />
      <FunctionField
        source="archivedAt"
        label="Archived"
        render={(record: AdvertiserRecord) => (record.archivedAt ? 'Yes' : 'No')}
      />
      <ShowButton />
      <EditButton />
      <ArchiveAdvertiserButton />
    </Datagrid>
  </List>
);
